import { isAppDebugEnabled } from '@/utils/debug/expandedConsoleLog';

/** 백엔드 DefectStatus enum ↔ WFS mngt_status 약어 */
const WFS_TO_CANONICAL = {
  FND: 'FOUND',
  SCH: 'SCHEDULE',
  CPL: 'COMPLETE'
};

const CANONICAL_CODES = ['FOUND', 'SCHEDULE', 'COMPLETE'];

/**
 * WFS 약어(FND) 또는 API enum(FOUND)을 통일 코드로 변환.
 * @param {unknown} raw
 * @returns {string|null}
 */
export function normalizeDefectStatus(raw) {
  if (raw == null || raw === '') {
    return null;
  }
  const upper = String(raw).trim().toUpperCase();
  if (WFS_TO_CANONICAL[upper]) {
    const result = WFS_TO_CANONICAL[upper];
    if (isAppDebugEnabled()) {
      console.log(`[DEFECT-STATUS] normalizeDefectStatus WFS: "${raw}" → "${result}"`);
    }
    return result;
  }
  if (CANONICAL_CODES.includes(upper)) {
    return upper;
  }
  // [DEBUG] 알 수 없는 상태값 — 필터 칩과 매칭되지 않을 수 있음
  if (isAppDebugEnabled()) {
    console.warn(
      `[DEFECT-STATUS] normalizeDefectStatus UNKNOWN: "${raw}" (upper: "${upper}") — canonical codes: ${CANONICAL_CODES.join(', ')}. 상태가 필터에 걸리지 않을 수 있습니다.`
    );
  }
  return upper;
}

/** 아바타/칩 색상 — defect-form.store 와 동일 의미 */
export function defectStatusAvatarColor(status) {
  const canonical = normalizeDefectStatus(status);
  const map = {
    FOUND: 'error',
    SCHEDULE: 'warning',
    COMPLETE: 'success'
  };
  return map[canonical] || 'grey darken-1';
}

/**
 * 결함 목록의 defectStatus 분포를 콘솔에 출력 (필터 매핑 검증용).
 * @param {Array<{ defectStatus?: string, seq?: number }>} defects
 * @param {string} source
 */
export function logDefectStatusDistribution(defects, source = 'unknown') {
  if (!isAppDebugEnabled()) {
    return { rawCounts: {}, normalizedCounts: {}, samples: {} };
  }
  const list = Array.isArray(defects) ? defects : [];
  const rawCounts = {};
  const normalizedCounts = {};
  const samples = {};

  list.forEach(d => {
    const raw = d?.defectStatus ?? '(empty)';
    const normalized = normalizeDefectStatus(d?.defectStatus) ?? '(empty)';
    rawCounts[raw] = (rawCounts[raw] || 0) + 1;
    normalizedCounts[normalized] = (normalizedCounts[normalized] || 0) + 1;
    if (!samples[raw]) {
      samples[raw] = { seq: d?.seq, raw, normalized };
    }
  });

  return { rawCounts, normalizedCounts, samples };
}
